/* kx-cart-timer.js
   Bis 27.09.2026 Inline-<script> in snippets/cart-timer.liquid (gerendert aus
   sections/header.liquid auf jeder Seite). Woertlich uebernommen, jetzt gecacht.
   Laden mit defer: window.initCartTimer existiert erst nach dem Parsen; die
   beiden Aufrufer in assets/header-actions.js pruefen es vorher. */
  if (!customElements.get('cart-timer')) {
    class CartTimer extends HTMLElement {
      constructor() {
        super();
        this.durationMinutes = 15;
        this.storageKey = 'cart_session_start_v1';
        this.seenKey = 'cart_session_seen_products_v1';
        this.animationFrameId = null;
      }

      connectedCallback() {
        this.initTimer();
      }
      
      disconnectedCallback() {
        if (this.animationFrameId) {
          cancelAnimationFrame(this.animationFrameId);
        }
      }

      initTimer() {
        const display = this.querySelector('.time-display');
        const container = this.querySelector('#cartSessionTimer');
        
        if (!display || !container) return;

        // Get IDs passed via data attribute
        let currentCartIds = [];
        try {
          currentCartIds = JSON.parse(this.dataset.productIds || '[]');
        } catch (e) {
          console.error('Error parsing cart product IDs', e);
        }

        let startTime = localStorage.getItem(this.storageKey);
        let seenProducts = JSON.parse(localStorage.getItem(this.seenKey) || '[]');
        
        const now = Date.now();
        
        // Smart Reset Check
        const hasNewProducts = currentCartIds.some(id => !seenProducts.includes(id));
        let shouldReset = false;

        if (hasNewProducts) {
            shouldReset = true;
            seenProducts = [...new Set([...seenProducts, ...currentCartIds])];
            localStorage.setItem(this.seenKey, JSON.stringify(seenProducts));
        } else if (!startTime) {
            shouldReset = true;
        } else {
            // Check expiry
            const elapsed = now - parseInt(startTime);
            const maxDuration = this.durationMinutes * 60 * 1000 + 600000; // Buffer
            if (elapsed > maxDuration) {
                shouldReset = true;
            }
        }

        if (shouldReset) {
            startTime = now;
            localStorage.setItem(this.storageKey, startTime);
        }

        this.startTime = parseInt(startTime);
        this.display = display;
        this.container = container;
        
        // Show immediately
        container.style.display = 'block';
        
        // Start Loop
        this.update();
      }

      update() {
        if (!this.startTime) return;

        let lastSecond = -1;
        const URGENT_THRESHOLD_MS = 2 * 60 * 1000; // last 2 minutes

        const updateFrame = () => {
            if (!this.isConnected) return; // Stop if removed from DOM

            const currentTime = Date.now();
            const elapsed = currentTime - this.startTime;
            const remaining = (this.durationMinutes * 60 * 1000) - elapsed;

            if (remaining <= 0) {
                // Reset loop
                this.startTime = Date.now();
                localStorage.setItem(this.storageKey, this.startTime);
                lastSecond = -1;
                this.container.classList.remove('timer-urgent');
                this.animationFrameId = requestAnimationFrame(updateFrame);
                return;
            }

            const m = Math.floor(remaining / 60000);
            const s = Math.floor((remaining % 60000) / 1000);

            // Only update DOM when the second actually changes — keeps
            // RAF cheap and gives us a clean hook for the "tick" cue.
            if (s !== lastSecond) {
                const timeStr = m + ':' + (s < 10 ? '0' + s : s);
                this.display.textContent = timeStr;

                if (lastSecond !== -1) {
                    this.display.classList.remove('time-display--tick');
                    // Force reflow so the animation re-triggers
                    void this.display.offsetWidth;
                    this.display.classList.add('time-display--tick');
                }
                lastSecond = s;

                // Toggle urgency state once we cross the threshold,
                // toggle it off again on reset.
                const urgent = remaining <= URGENT_THRESHOLD_MS;
                this.container.classList.toggle('timer-urgent', urgent);
            }

            this.container.style.display = 'block';

            this.animationFrameId = requestAnimationFrame(updateFrame);
        };
        this.animationFrameId = requestAnimationFrame(updateFrame);
      }
    }
    customElements.define('cart-timer', CartTimer);
  }
  
  // Global function to reinitialize cart timer when drawer opens
  window.initCartTimer = function() {
    const timer = document.querySelector('cart-timer');
    if (timer) {
      // Reset and reinitialize
      const container = timer.querySelector('#cartSessionTimer');
      if (container) {
        container.style.display = 'block';
      }
      // Force reinitialization by calling initTimer if exposed, or recreate
      if (timer.initTimer) {
        timer.initTimer();
      }
    }
  };
  
  // Auto-detect when cart drawer opens and reinitialize
  (function() {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1) {
            // Check if cart-timer was added
            if (node.matches && node.matches('cart-timer')) {
              // Timer added, will auto-init via connectedCallback
            }
            // Check if drawer opened (dialog open attribute)
            if (node.querySelector && node.querySelector('cart-timer')) {
              const timer = node.querySelector('cart-timer');
              const container = timer.querySelector('#cartSessionTimer');
              if (container) container.style.display = 'block';
            }
          }
        }
        // Also check attribute changes for dialog[open]
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          if (mutation.target.matches && mutation.target.matches('.cart-drawer__dialog[open]')) {
            const timer = mutation.target.querySelector('cart-timer');
            if (timer) {
              const container = timer.querySelector('#cartSessionTimer');
              if (container) container.style.display = 'block';
            }
          }
        }
      }
    });
    
    observer.observe(document.body, { 
      childList: true, 
      subtree: true,
      attributes: true,
      attributeFilter: ['open']
    });
    
    // Also listen for cart:refresh events
    document.addEventListener('cart:refresh', () => {
      setTimeout(window.initCartTimer, 100);
    });
  })();
